import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const BadgeContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const Super = styled.sup`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  min-width: 14px;
  height: 20px;
  padding: 0 ${theme.spacing.xxs};
  font-size: ${theme.fontSizes.xxs};
  border-radius: 20px;
  transform: translate(25%, -25%);

  &.dot {
    width: 8px;
    min-width: 0;
    height: 8px;
    padding: 0;
    border-radius: 50%;
  }
`;

const Badge = ({
  children,
  count,
  maxCount,
  dot,
  backgroundColor,
  textColor,
  ...props
}) => {
  const colorStyles = {
    backgroundColor,
    color: textColor,
  };

  let badge = null;

  if (!dot && count > 0) {
    badge = (
      <Super style={colorStyles}>
        {maxCount && count > maxCount ? `${maxCount}+` : count}
      </Super>
    );
  }

  if (dot && count > 0) {
    badge = <Super className="dot" style={colorStyles} />;
  }

  return (
    <BadgeContainer {...props}>
      {children}
      {badge}
    </BadgeContainer>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  count: PropTypes.number,
  maxCount: PropTypes.number,
  dot: PropTypes.bool,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
};

Badge.defaultProps = {
  count: 1,
  maxCount: 20,
  dot: false,
  backgroundColor: theme.colors.primary,
  textColor: theme.colors.white,
};

export default Badge;
